export default {
	security: {
		securityBind: "Pag-bind ng Seguridad",
		securitySettings: "Mga Setting ng Seguridad",
		level: "Katamtaman",
		confirm: "Kumpirmahin",
		submitting: "Isinusumite...",
		add: "Idagdag",
		change: "Baguhin",
		success: "Matagumpay na na-update",
		select: "Piliin",

		birthday: "Kaarawan ng Contact",
		birthdayDesc: "I-bind ang kaarawan ng contact para sa mas madaling komunikasyon. Mananatiling protektado ang iyong personal na impormasyon.",
		month: "Buwan",
		day: "Araw",
		year: "Taon",
		birthdayRequired: "Kinakailangan ang kaarawan.",
		invalidBirthday: "Hindi wastong kaarawan.",
		invalidMonth: "Hindi wastong buwan.",
		invalidDay: "Hindi wastong araw.",
		invalidYear: "Hindi wastong taon.",
		updateBirthdayFail: "Hindi na-update ang kaarawan",
		birthdayVerify: "Pag-verify ng pag-bind ng kaarawan",
		birthdayVerifyDesc: "I-bind ang iyong kaarawan upang mapabuti ang seguridad ng iyong account.",

		email: "Contact Email",
		emailDesc: "Email para sa seguridad ng account. Ikaw lang ang maaaring mag-bind nito.",
		emailRequired: "Kinakailangan ang email.",
		emailInvalid: "Maling email address.",
		updateEmailFail: "Hindi na-update ang email",
		emailVerify: "Pag-verify ng pag-bind ng email",
		emailVerifyDesc: "I-verify ang iyong email address upang mapabuti ang seguridad ng iyong account.",

		phone: "Numero ng Telepono",
		bindPhone: "I-bind ang Numero ng Telepono",
		phoneDesc: "Numero ng telepono para sa seguridad ng account. Ikaw lang ang maaaring mag-bind nito.",
		phoneRequired: "Kinakailangan ang numero ng telepono.",
		phoneUsed: "Mangyaring gumamit ng ibang numero ng telepono.",
		updatePhoneFail: "Hindi na-update ang numero ng telepono",
		noCode: "Walang natanggap na code?",
		smsHelp: "Kung ilang beses mo nang sinubukan ngunit hindi mo pa rin natatanggap ang verification code.",
		smsTips1: "1. Suriin kung tama ang mobile number na inilagay mo.",
		smsTips2: "2. Suriin kung luma na ang iyong mobile number.",
		smsTips3: "3. Suriin kung nasa SMS bin ang mensahe.",
		smsTips4: "4. Maaaring ma-delay ang mensahe nang ilang minuto.",
		phoneVerify: "Pag-verify ng pag-bind ng numero ng telepono",
		phoneVerifyDesc: "I-verify ang iyong numero ng telepono upang mapabuti ang seguridad ng iyong account.",

		setPassword: "Itakda ang Password",
		passwordDesc: "Itakda ang iyong sign in password.",
		clickSelectBirthday: "I-click para piliin ang kaarawan",
		selectBirthday: "Pumili ng Kaarawan",
		confirm: "Kumpirmahin",
		cancel: "Kanselahin",
		withdrawPassword: "Password sa Pag-withdraw",
		withdrawpasswordDesc: "I-set ang iyong password sa pag-withdraw ng pera.",
		set: "I-set",
	},

	contactPhone: {
		title: "Baguhin ang Numero ng Telepono",
		titleMobile: "Baguhin",
		description: "Magdagdag ng contact phone number para mas madaling makipag-ugnayan. Mananatiling protektado ang iyong personal na impormasyon.",
		label: "Contact Phone Number",
		confirm: "Kumpirmahin",
		submitting: "Isinusumite...",
		required: "Kinakailangan ang numero ng telepono",
		invalid: "Di-wasto ang numero ng telepono",
		success: "Matagumpay na na-update ang numero ng telepono!",
		updateFailed: "Nabigo ang pag-update",
		tryAgain: "Nabigo ang pag-update, subukan muli sa ibang pagkakataon",
		verifyTitleMobile: "Veripikasyon ng Telepono",
		titleMobile: "I-bind ang Telepono",
		changeTitleMobile: "Baguhin ang Telepono",
		securityTip: "Telepono para sa seguridad ng account. Ikaw lang ang makakapag-bind nito.",
		placeholder: "Numero ng Telepono",
		noCodeReceived: "Walang natanggap na code?",
		codeDescription: "Ilagay ang 6-digit na verification code na ipinadala sa iyong mga detalye ng contact sa ibaba:",
		resendIn: "Ipadala muli sa loob ng {countdown} s",
		resend: "Ipadala muli",
		submitting: "Ipinapasa...",
		confirm: "Kumpirmahin",
		invalidCode: "Mangyaring magpasok ng wastong 6-digit code",
		required: "Kailangan ang numero ng telepono",
		invalid: "Mangyaring magpasok ng wastong numero ng telepono",
		success: "Matagumpay na nai-update",
		updateFailed: "Bigo ang pag-update",
		tryAgain: "Mangyaring subukang muli mamaya"
	},

	contactEmail: {
		title: "Baguhin ang Email",
		titleMobile: "Baguhin",
		description: "Magdagdag ng contact email para mas madaling makipag-ugnayan. Mananatiling protektado ang iyong personal na impormasyon.",
		label: "Contact Email",
		placeholder: "Email",
		confirm: "Kumpirmahin",
		submitting: "Isinusumite...",
		required: "Hindi maaaring walang laman ang email",
		invalid: "Mangyaring maglagay ng wastong email address",
		success: "Matagumpay na na-update ang email!",
		updateFailed: "Nabigo ang pag-update",
		tryAgain: "Nabigo ang pag-update, subukan muli sa ibang pagkakataon",
		verifyTitleMobile: "Veripikasyon ng Email",
		titleMobile: "I-bind ang Email",
		changeTitleMobile: "Baguhin ang Email",
		securityTip: "Email para sa seguridad ng account. Ikaw lang ang makakapag-bind nito.",
		noCodeReceived: "Walang natanggap na code?",
		codeDescription: "Ilagay ang 6-digit na verification code na ipinadala sa iyong mga detalye ng contact sa ibaba:",
		resendIn: "Ipadala muli sa loob ng {countdown} s",
		resend: "Ipadala muli",
		submitting: "Ipinapasa...",
		confirm: "Kumpirmahin",
		invalidCode: "Mangyaring magpasok ng wastong 6-digit code",
		required: "Kailangan ang email",
		invalid: "Mangyaring magpasok ng wastong email address",
		success: "Matagumpay na nai-update",
		updateFailed: "Bigo ang pag-update",
		tryAgain: "Mangyaring subukang muli mamaya"
	},

	accountInfo: {
		profileInfo: "Impormasyon ng Profile",
		contactInfo: "Impormasyon sa Pakikipag-ugnayan",
		privacy: "Privacy",
		contactEmail: "Contact Email",
		contactPhone: "Contact Phone Number",
		addEmailDesc: "Magdagdag ng contact email para mas madaling makipag-ugnayan. Mananatiling protektado ang iyong personal na impormasyon.",
		addPhoneDesc: "Magdagdag ng contact phone number para mas madaling makipag-ugnayan. Mananatiling protektado ang iyong personal na impormasyon.",
		hideUsername: "Itago ang aking username sa mga pampublikong listahan",
		add: "Magdagdag",
		change: "Baguhin",
		idLabel: "ID: ",
		vip: "VIP ",
		player: "PLAYER",
		copied: "Nakopya!",
		hideSuccess: "Matagumpay na naitago ang username",
		showSuccess: "Matagumpay na naipakita ang username",
		operationFailed: "Nabigo ang operasyon",
		editProfile: "I-edit ang Profile",
		contactInfo: "Impormasyon sa Pakikipag-ugnayan",
		contactEmail: "Email sa Pakikipag-ugnayan",
		emailTip: "Magdagdag ng email sa pakikipag-ugnayan para sa mas madaling komunikasyon. Mananatiling protektado ang iyong personal na impormasyon.",
		change: "Baguhin",
		addEmail: "Magdagdag ng Email",
		contactPhone: "Numero ng Telepono sa Pakikipag-ugnayan",
		phoneTip: "Magdagdag ng iyong numero ng telepono para sa ligtas na pag-verify ng account.",
		addPhone: "Magdagdag ng Numero ng Telepono",
		birthdayBind: "Pag-verify ng pag-bind ng kaarawan",
		birthdayTip: "I-bind ang iyong kaarawan upang mapabuti ang seguridad ng iyong account.",
		addBirthday: "Magdagdag ng Kaarawan",
		personalInfo: "Impormasyon ng Personal",
		personalTip: "I-verify ang iyong pagkakakilanlan upang ma-unlock ang higit pang mga serbisyo. Ligtas ang iyong data.",
		verifyNow: "I-verify Ngayon",
		hideUsernameTip: "Kapag pinagana, hindi makikita ng ibang mga user ang iyong username sa mga pampublikong listahan.",
	},

	kyc: {
		title: "Pag-verify ng Pagkakakilanlan",
		verifyIdentity: "I-verify ang iyong pagkakakilanlan",
		completeDesc: "Kumpletuhin ang pag-verify ng pagkakakilanlan upang panatilihing ligtas ang iyong account at ma-unlock ang lahat ng feature.",
		failed: "Nabigo ang pag-verify. Pakisubukan muli.",
		reVerify: "I-verify muli",
		checkYouOut: "I-verify natin ang iyong pagkakakilanlan",
		prepareDoc: "Ihanda ang iyong dokumento",
		prepareDocDesc: "Maghanda ng balidong dokumento ng pagkakakilanlan.",
		useSmartphone: "Gumamit ng smartphone",
		useSmartphoneDesc: "Kakailanganin mo ng smartphone upang makumpleto ang pag-verify.",
		scanQr: "I-scan ang QR code",
		scanQrDesc: "I-scan ang QR code gamit ang iyong telepono upang magpatuloy sa mobile.",
		noSmartphone: "Walang smartphone?",
		completeOnMobile: "Kumpletuhin sa mobile"
	},

	verify: {
		title: "Pag-verify",
		personalVerification: "Personal na Pag-verify",
		weak: "Mahina",
		level1: "Antas 1",
		personalInfo: "Personal na Impormasyon",
		personalInfoDesc: "Kumpletuhin ang iyong personal na impormasyon upang mapabuti ang seguridad ng iyong account.",
		verifyNow: "Mag-verify Ngayon",
		level2: "Antas 2",
		kycVerification: "Pag-verify ng KYC",
		kycDesc: "Kumpletuhin ang pag-verify ng KYC upang ma-unlock ang mas mataas na limit at buong akses.",
		docTip: "Pakisiguro na malinaw at balido ang iyong mga dokumento bago isumite."
	},

	personalInfo: {
		verify: "Pag-verify",
		completeInfo: "Kumpletuhin ang Iyong Impormasyon",
		completeInfoDesc: "Punan ang iyong personal na detalye upang makumpleto ang pag-verify.",
		firstName: "Pangalan",
		paternalSurname: "Apelyido ng Ama",
		maternalSurname: "Apelyido ng Ina",
		contactNumber: "Numero ng Kontak",
		phoneUsed: "Ginagamit na ang numero ng telepono na ito.",
		contactEmail: "Contact Email",
		invalidEmail: "Di-wastong email address.",
		detailedAddress: "Detalyadong Address",
		city: "Lungsod",
		street: "Kalye",
		neighborhood: "Barangay",
		houseNumber: "Numero ng Bahay",
		postalCode: "Postal Code",
		save: "I-save",
		male: "Lalaki",
		female: "Babae"
	},

	withdrawPassword: {
		changeTitle: "Baguhin ang Password sa Withdrawal",
		setTitle: "Itakda ang Password sa Withdrawal",
		changeDesc: "Ilagay ang iyong lumang password at magtakda ng bagong password sa withdrawal.",
		setDesc: "Magtakda ng password sa withdrawal upang protektahan ang iyong pondo.",
		oldPlaceholder: "Lumang Password sa Withdrawal",
		newPlaceholder: "Bagong Password sa Withdrawal",
		confirmPlaceholder: "Kumpirmahin ang Password sa Withdrawal"
	},

	contactBirthday: {
		title: "Kaarawan ng Contact",
		desc: "I-bind ang kaarawan ng contact para sa mas madaling komunikasyon. Mananatiling protektado ang iyong personal na impormasyon.",
		label: "Kaarawan ng Contact",
		invalid: "Hindi wastong kaarawan."
	},

	changePassword: {
		title: "Baguhin ang Password",
		expiredDesc: "Nag-expire na ang iyong password. Magtakda ng bagong password upang magpatuloy.",
		verifyOldDesc: "Ilagay ang iyong lumang password at magtakda ng bago.",
		passwordPlaceholder: "Lumang Password",
		newPlaceholder: "Bagong Password",
		confirmPlaceholder: "Kumpirmahin ang Bagong Password",
		lengthError: "Ang password ay dapat 6 hanggang 30 karakter.",
		sameAsOld: "Hindi maaaring pareho ang bagong password sa luma.",
		confirmRequired: "Pakikumpirma ang iyong bagong password.",
		notMatch: "Hindi magkatugma ang mga password.",
		success: "Matagumpay na nabago ang password",
		failed: "Nabigo ang pagbabago ng password"
	},

	settingsNav: {
		title: "Mga Setting",
		accountInfo: "Impormasyon ng Account",
		security: "Seguridad"
	},

	verificationBirthday: {
		title: "Kaarawan",
		securityTip: "Kaarawan para sa seguridad ng account. Ikaw lang ang pwedeng mag-bind nito.",
		clickSelectBirthday: "I-click para piliin ang kaarawan",
		invalidBirthday: "Di-balidong kaarawan",
		submitting: "Ipinapadala...",
		confirm: "Kumpirmahin",
		cancel: "Kanselahin",
		selectBirthday: "Piliin ang Kaarawan",
		birthdayRequired: "Kinakailangan ang kaarawan",
		updateBirthdayFail: "Bigo sa pag-update ng kaarawan",
		success: "Matagumpay na nai-update"
	}
};